export const TOKEN_TYPE = 'Bearer'

export const TOKEN_EXPIRE_AT_FIELD_NAME = 'expires_at'

export const TOKEN_STORAGE_KEY_NAME = 'accessToken'

export const REFRESH_TOKEN_STORAGE_KEY_NAME = 'refreshToken'

export const LANGUAGE_STORAGE_KEY_NAME = 'language'

export const WEB_PUSH_TOKEN_STORAGE_KEY_NAME = 'webPushToken'
